import { useEffect, useState } from 'react';

/**
 * The browser's microphone permission, kept current: `prompt` means opening the mic shows the browser's prompt
 * (Safari set to Ask reports it before every call). Null where the browser won't say, which shows no hint.
 */
export function useMicPermission(): PermissionState | null {
  const [state, setState] = useState<PermissionState | null>(null);
  useEffect(() => {
    let status: PermissionStatus | null = null;
    let gone = false;
    const update = () => setState(status?.state ?? null);
    navigator.permissions?.query({ name: 'microphone' as PermissionName }).then(
      (s) => {
        if (gone) return;
        status = s;
        update();
        s.addEventListener('change', update);
      },
      () => {}, // a browser that can't be asked about 'microphone' rejects
    );
    return () => {
      gone = true;
      status?.removeEventListener('change', update);
    };
  }, []);
  return state;
}
